const require_package = require('../package.cjs');

//#region src/lib/devMsg.ts
/**
* Returns a `prismic.dev/msg` URL for a given message slug.
*
* @example
*
* ```ts
* devMsg("missing-param")
* // => "https://prismic.dev/msg/client/v1.2.3/missing-param.md"
* ```
*
* @param slug - Slug for the message. This corresponds to a Markdown file in
*   the Git repository's `/messages` directory.
*
* @returns The `prismic.dev/msg` URL for the given slug.
*/
const devMsg = (slug) => {
	return `https://prismic.dev/msg/client/v${require_package.version}/${slug}`;
};

//#endregion
exports.devMsg = devMsg;
//# sourceMappingURL=devMsg.cjs.map